"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nodeType = exports.UiConfigSchema = exports.TaskSchema = void 0;
const tape_sanitizer_1 = require("@finley-technologies/tape-sanitizer");
const v4_1 = require("zod/v4");
exports.TaskSchema = v4_1.z.discriminatedUnion('mode', [
    tape_sanitizer_1.ConvertRangeConfigSchema.extend({
        operation: v4_1.z.literal('xlsx2csv'),
        mode: v4_1.z.literal('convertRange'),
        srcArtifactSlug: v4_1.z.string(),
    }),
    v4_1.z.object({
        operation: v4_1.z.literal('xlsx2csv'),
        mode: v4_1.z.literal('extractValues'),
        extract: v4_1.z.array(tape_sanitizer_1.ExtractValueConfigSchema),
        srcArtifactSlug: v4_1.z.string(),
    }),
]);
exports.UiConfigSchema = v4_1.z.discriminatedUnion('mode', [
    tape_sanitizer_1.ConvertRangeConfigSchema.extend({
        operation: v4_1.z.literal('xlsx2csv'),
        mode: v4_1.z.literal('convertRange'),
    }),
    v4_1.z.object({
        operation: v4_1.z.literal('xlsx2csv'),
        mode: v4_1.z.literal('extractValues'),
        extract: v4_1.z.array(tape_sanitizer_1.ExtractValueConfigSchema),
    }),
]);
exports.nodeType = 'operation_xlsx2csv';
//# sourceMappingURL=types.js.map